import axios from "axios";
import { SERVER_URL } from "../config";

/* ---------- FETCH REGIONS ---------- */
export const fetchRegions = async () => {
    try {
        const res = await axios.get(`${SERVER_URL}/customerProfile.php`, {
            params: { action: "regions" }
        });
        console.log("📥 Regions API response:", res.data);
        return res.data;
    } catch (err) {
        console.error("❌ Error fetching regions:", err);
        throw err;
    }
};

/* ---------- FETCH TERRITORIES ---------- */
export const fetchTerritories = async (region = "") => {
    try {
        const params = { action: "territories" };
        if (region) params.region = region;

        const res = await axios.get(`${SERVER_URL}/customerProfile.php`, { params });
        console.log("📥 Territories API response:", res.data);
        return res.data;
    } catch (err) {
        console.error("❌ Error fetching territories:", err);
        throw err;
    }
};

/* ---------- FETCH PARTIES ---------- */
export const fetchParties = async (region = "", territory = "") => {
    try {
        const params = { action: "parties" };
        if (region) params.region = region;
        if (territory) params.territory = territory;

        const res = await axios.get(`${SERVER_URL}/customerProfile.php`, { params });
        console.log("📥 Parties API response:", res.data);
        return res.data;
    } catch (err) {
        console.error("❌ Error fetching parties:", err);
        throw err;
    }
};

/* ---------- FETCH CUSTOMER PROFILE REPORT ---------- */
export const fetchCustomerProfileReport = async ({
    fromDate,
    toDate,
    party = "",
    region = "",
    territory = "",
    searchText = "",
    paymentType = "",
}) => {
    try {
        const payload = {
            action: "report",
            from_date: fromDate,
            to_date: toDate,
            party_name: party,
            region: region,
            territory: territory,
            search: searchText,
            payment_type: paymentType,
        };
        
        console.log("📤 Sending report request:", payload);
        
        const res = await axios.post(`${SERVER_URL}/customerProfile.php`, payload);
        console.log("📥 Report API response:", res.data);
        return res.data;
    } catch (err) {
        console.error("❌ Error fetching customer profile report:", err);
        throw err;
    }
};

/* ---------- FETCH PAYMENT HISTORY REPORT ---------- */
export const fetchPaymentHistoryReport = async ({
    fromDate,
    toDate,
    party = "",
    searchText = ""
}) => {
    try {
        const payload = {
            action: "payment_history",
            from_date: fromDate,
            to_date: toDate,
            party_name: party,
            search: searchText
        };
        
        console.log("📤 Sending payment history request:", payload);
        
        const res = await axios.post(`${SERVER_URL}/paymentHistory.php`, payload);
        console.log("📥 Payment history API response:", res.data);
        return res.data;
    } catch (err) {
        console.error("❌ Error fetching payment history:", err);
        throw err;
    }
};